import { IRosaViewPreferences } from 'gen/ApiClient';
import React from 'react';

interface IContext {
	rosaViewPreferences: IRosaViewPreferences;
	reload: VoidFunction;
}

export const RosaViewPreferencesPreloadCacheContext = React.createContext<IContext>(undefined as any);
